import getdata_new_kpi from "../../../../src/assets/images/docs/reference/functions/getdata_new_kpi.gif";
import * as React from 'react';
export default {
  getdata_new_kpi,
  React
};